<template>
    <template v-if="fieldData && Array.isArray(fieldData)">
        <fieldset v-if="this.topParent.fieldSets[this.fieldData.keyName]" :id="fieldData.fieldset" class="app-modal-dialog__section">
            <legend class="app-modal-dialog__section-title">{{ legendName }}</legend>
            <field-set v-for="(value, index) in fieldData"
                :key="`${keyId}${index}`"
                :field-data="value"
                :key-id="`${keyId}${index}`"
                :top-parent="topParent"
                :child-field-name="childFieldName ?? null">
            </field-set>
        </fieldset>
        <template v-else>
            <field-set v-for="(value, index) in fieldData"
                :key="`${keyId}${index}`"
                :field-data="value"
                :key-id="`${keyId}${index}`"
                :top-parent="topParent"
                :child-field-name="childFieldName ?? null">
            </field-set>
        </template>

    </template>
    <template v-else-if="fieldData && fieldData.children?.length > 0">
        <fieldset v-if="legendName" :id="fieldData.fieldset" class="app-modal-dialog__section">
            <legend class="app-modal-dialog__section-title">{{ legendName }}</legend>
            <field-set
                :key="keyId"
                :field-data="fieldData.children"
                :key-id="`${fieldData.fieldset}`"
                :top-parent="topParent"
                :child-field-name="topParent.fieldSetChildren[fieldData.keyName] ?? null">
            </field-set>
        </fieldset>
        <template v-else>
            <field-set
                :key="keyId"
                :field-data="fieldData.children"
                :key-id="`${fieldData.fieldset}`"
                :top-parent="topParent"
                :child-field-name="topParent.fieldSetChildren[fieldData.keyName] ?? null">
            </field-set>
        </template>
    </template>
    <div v-else-if="fieldData && topParent.editableKeyName(fieldData.keyName)" :id="keyId">
        <label :for="keyId" class="app-modal-dialog__section-input-label">
            {{ topParent.getKeyLabels(fieldData.keyName).label }}
            <svg data-bs-toggle="dropdown" class="element-icon--tooltip-help element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-tooltip-help"></use></svg>
            <div class="app-tooltip--screen-content-description app-tooltip dropdown-menu">
                <h4 class="app-tooltip__title">{{ topParent.getKeyLabels(fieldData.keyName).label }}</h4>
                <div class="app-tooltip__body">
                    {{ topParent.getKeyLabels(fieldData.keyName).description }}
                </div>
            </div>
        </label>
        <template v-if="topParent.inputTypeByKeyName(fieldData.keyName) === 'textarea'">
            <div class="input textarea">
                <textarea
                    :key="keyId"
                    :name="topParent.getModel(fieldData.fieldset)"
                    :placeholder="fieldData.keyName"
                    :value="fieldData.value"
                    @input="topParent.updateScreenData(fieldData.fieldset, $event.target.value)"
                ></textarea>
            </div>
        </template>
        <template v-else-if="topParent.inputTypeByKeyName(fieldData.keyName) === 'checkbox'">
            <div class="checkbox">
                <input 
                    :key="keyId"
                    :type="topParent.inputTypeByKeyName(fieldData.keyName)"
                    :name="topParent.getModel(fieldData.fieldset)"
                    :placeholder="fieldData.keyName"
                    :checked="fieldData.value"
                    @input="topParent.updateScreenData(fieldData.fieldset, $event.target.checked)" />
            </div>
        </template>
        <template v-else>
            <div class="input text">
                <input 
                    :key="keyId"
                    :type="topParent.inputTypeByKeyName(fieldData.keyName)"
                    :name="topParent.getModel(fieldData.fieldset)"
                    :placeholder="fieldData.keyName"
                    :value="fieldData.value"
                    :checked="fieldData.value"
                    @input="topParent.updateScreenData(fieldData.fieldset, $event.target.value)" />
            </div>
        </template>
    </div>
</template>


<script>

export default {
    props: {
        fieldData: {
            type: [Object, Array, String, Boolean],
        },
        keyId: {
            type: String,
        },
        topParent: {
            type: Object,
            default: null
        },
        childFieldName: {
            type: String,
            default: null
        },
    },
    data () {
        return {

        }
    },
    computed: {
        buttonLabel () {
            return this.label
        },
        legendName() {
            console.log('legendName', this.fieldData.keyName, this.childFieldName, this.topParent.fieldSets[this.fieldData.keyName] || this.childFieldName || null)
            return this.topParent.fieldSets[this.fieldData.keyName] || this.childFieldName?.replace('{{index}}', this.fieldData.keyName + 1) || null
        },
    },
    methods: {

    },
    created() {
        //console.log('Field-set created', this.keyId, this.fieldData, typeof this.fieldData, Array.isArray(this.fieldData));
    },
}
</script>
